import { Dispatch } from 'redux'

import * as BookTypes from './Book.types'
import * as BookApi from './Book.api'
import { throwErrorWithMessage } from 'api/apiMessages'

export const setCurrentBookInfo =
  (bookId: string | null, bookMode: BookTypes.BookMode | null) =>
  (dispatch: Dispatch<BookTypes.SetCurrentBookIdAction>) => {
    return dispatch({ type: BookTypes.BookServiceActionTypes.SetCurrentBookId, bookId, bookMode })
  }

export const setBookStarted = (timestamp: number | null) => (dispatch: Dispatch<BookTypes.SetBookStaredAction>) => {
  return dispatch({ type: BookTypes.BookServiceActionTypes.SetBookStarted, timestamp })
}

export const asyncGetAllBooks = (search?: string) => {
  return async (dispatch: Dispatch<BookTypes.AsyncGetAllBooksAction>) => {
    try {
      const data = await BookApi.getAllBooks(search)

      return dispatch({ type: BookTypes.BookServiceActionTypes.AsyncGetAll, bookEntities: data })
    } catch (error) {
      return throwErrorWithMessage(error)
    }
  }
}

export const asyncGetBooksProgress = () => {
  return async (dispatch: Dispatch<BookTypes.AsyncGetBooksProgressAction>) => {
    try {
      const data = await BookApi.getBookProgress()

      return dispatch({ type: BookTypes.BookServiceActionTypes.AsyncGetBooksProgress, progressEntities: data })
    } catch (error) {
      return throwErrorWithMessage(error)
    }
  }
}

export const asyncCreateProgressEntity = (bookId: string) => {
  return async (dispatch: Dispatch<BookTypes.AsyncCreateProgressEntityAction>) => {
    try {
      const data = await BookApi.createBookProgress(bookId)

      dispatch({ type: BookTypes.BookServiceActionTypes.AsyncCreateProgressEntity, progressEntity: data })

      return data
    } catch (error) {
      return throwErrorWithMessage(error)
    }
  }
}

export const asyncUpdateProgressEntity = (data: {
  index: number
  progressId: string
  isCompleted: boolean
  bookMode: BookTypes.BookMode
}) => {
  return async (dispatch: Dispatch<BookTypes.AsyncUpdateProgressEntityAction>) => {
    try {
      const response = await BookApi.updateBookProgress(data)

      return dispatch({
        type: BookTypes.BookServiceActionTypes.AsyncUpdateProgressEntity,
        progressEntity: response.data
      })
    } catch (error) {
      return throwErrorWithMessage(error)
    }
  }
}

export const setBookFavourite = (bookProgressId: string, updatedValues: { reading?: boolean; listening?: boolean }) => {
  return async (dispatch: Dispatch<BookTypes.AsyncUpdateProgressEntityAction>) => {
    try {
      const { data } = await BookApi.updateIsBookFavorite(bookProgressId, updatedValues)

      return dispatch({
        type: BookTypes.BookServiceActionTypes.AsyncUpdateProgressEntity,
        progressEntity: data
      })
    } catch (error) {
      return throwErrorWithMessage(error)
    }
  }
}

export const rateBook = (bookProgressId: string, rate: BookTypes.BookRate = BookTypes.BookRate.GOOD) => {
  return async (dispatch: Dispatch<BookTypes.AsyncUpdateProgressEntityAction>) => {
    try {
      const { data } = await BookApi.rateBook(bookProgressId, rate)

      return dispatch({
        type: BookTypes.BookServiceActionTypes.AsyncUpdateProgressEntity,
        progressEntity: data
      })
    } catch (error) {
      return throwErrorWithMessage(error)
    }
  }
}

export const asyncGetPlacementTest = () => {
  return async (dispatch: Dispatch<BookTypes.AsyncGetPlacementTestAction>) => {
    try {
      const { data } = await BookApi.getPlacementTest()

      dispatch({ type: BookTypes.BookServiceActionTypes.AsyncGetPlacementTest, placementTestEntity: data })

      return data
    } catch (error) {
      return throwErrorWithMessage(error)
    }
  }
}

export const asyncCreatePlacementScore = (placementTestId: string) => {
  return async (dispatch: Dispatch<BookTypes.AsyncCreatePlacementTestScoreAction>) => {
    try {
      const { data } = await BookApi.createPlacementTestScore(placementTestId)

      return dispatch({
        type: BookTypes.BookServiceActionTypes.AsyncCreatePlacementTestScore,
        placementTestScoreEntity: data
      })
    } catch (error) {
      return throwErrorWithMessage(error)
    }
  }
}

export const asyncUpdatePlacementScore = (placementId: string, exerciseId: string, score: number) => {
  return async (dispatch: Dispatch<BookTypes.AsyncUpdatePlacementTestScoreAction>) => {
    try {
      const { data } = await BookApi.updatePlacementTestScore({ placementId, exerciseId, score })

      return dispatch({
        type: BookTypes.BookServiceActionTypes.AsyncUpdatePlacementTestScore,
        placementTestScoreEntity: data
      })
    } catch (error) {
      return throwErrorWithMessage(error)
    }
  }
}
